import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import AuroraBackground from "@/components/AuroraBackground";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import BookAppointment from "@/pages/BookAppointment";
import LiveQueue from "@/pages/LiveQueue";
import FindMyBooking from "@/pages/FindMyBooking";
import Prescriptions from "@/pages/Prescriptions";
import ScrollToTop from "@/components/ScrollToTop";
import PatientReceipt from "@/pages/PatientReceipt";

function PatientAppShell() {
  const location = useLocation();
  const isReceipt = location.pathname.startsWith("/receipt/");

  return (
    <>
      {!isReceipt && <SmoothScroll />}
      {!isReceipt && <ScrollToTop />}
      {!isReceipt && <AuroraBackground />}
      {!isReceipt && <Navbar />}
      <main className={isReceipt ? "min-h-screen" : "min-h-screen bg-background"}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/book" element={<BookAppointment />} />
          <Route path="/queue" element={<LiveQueue />} />
          <Route path="/find" element={<FindMyBooking />} />
          <Route path="/my-health/:id" element={<Prescriptions />} />
          <Route path="/my-health" element={<Prescriptions />} />
          <Route path="/receipt/:secureToken" element={<PatientReceipt />} />
        </Routes>
      </main>
      {!isReceipt && <Toaster position="top-center" richColors />}
    </>
  );
}

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false} disableTransitionOnChange>
      <BrowserRouter>
        <PatientAppShell />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
